// @flow

const NOT_NUMBERS = /[^0-9]+/ug;

export const getPhoneNumberNormalizerWithLength = (length: number) => (phoneNumber: ?string): string => {
  if (!phoneNumber) {
    return '';
  }

  return phoneNumber.replace(NOT_NUMBERS, '').substr(0, length);
};
